<div [id]="id()" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-96 max-h-full rounded-lg shadow bg-primary-purple-light-2 p-6 cursor-default">
        <div class="relative rounded-lg dark:bg-gray-700">
            @if (duplicating()) {
                <div class="p-6">
                    <article class="flex w-full ml-10 justify-center items-center">
                        <ng-lottie width="75%" height="75%" [options]="optionsLoading" (animationCreated)="utilsService.animationCreated($event, 1)" />
                    </article>
                    <div class="flex items-center justify-center">
                        <h3 class="text-xl font-bold mb-4 -mt-4 text-primary-purple-light">{{ literalService.get('alterations.duplicate.title', true) }}</h3>
                    </div>
                </div>
            } @else {
                <form #form novalidate (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
                    <div class="flex flex-row items-center">
                        <h3 class="w-full text-lg font-bold text-primary-purple">{{ literalService.get('alterations.duplicate.title', true) }}</h3>
                        <button (click)="close()" type="button" class="right-6 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                            <img [src]="images.close" class="h-6 w-6" />
                        </button>
                    </div>
                    <div class="flex flex-col gap-1">
                        <div class="flex items-center">
                            <img [src]="images.alterations.alteration" alt="duplicate" class="h-6 w-6 filter-primary-purple-light" />
                            <label class="font-normal text-base">{{ literalService.get('alterations.duplicate.description', true) }}</label>
                        </div>
                        <input type="text" [(ngModel)]="alterationName" (change)="change(alterationName)" [ngModelOptions]="{standalone: true}" [placeholder]="literalService.get('alterations.duplicate.placeholder', true)" class="block w-full px-3 py-2 bg-white border rounded-s rounded-e text-base font-normal placeholder-slate-400 focus:outline-none" />
                    </div>
                    <div class="flex gap-2 pt-4">
                        <button type="button" class="secondary border-2 font-semibold h-11 w-full uppercase cursor-pointer bg-white" (click)="close()">{{ literalService.get('cancel', true) }}</button>
                        <button type="submit" class="primary border-2 font-semibold h-11 w-full uppercase cursor-pointer text-white">{{ literalService.get('continue', true) }}</button>
                    </div>
                </form>
            }
        </div>
    </div>
</div>
